// One navigation model for the application and wiki sidebar adapters.
// Plot access is enforced at its destination, independently of CM staff status.
export const sidebarNavigation = [
    { title: 'Tools', links: [
        { label: 'Character Manager', to: '/character', kind: 'app' },
        { label: 'Player Wiki', to: '/wiki', kind: 'wiki', requiresWikiRoutes: true },
        { label: 'Plot Wiki', to: '/plot/wiki', kind: 'wiki', requiresWikiRoutes: true },
    ] },
    { title: 'Staff Tools', staffOnly: true, links: [
        { label: 'Event Manager', to: '/event-manager', kind: 'app' },
        { label: 'Transform Editor', to: '/transform', kind: 'app' },
        { label: 'Event Checkout', to: '/event-checkout', kind: 'app' },
    ] },
    { title: 'Events', links: [
        { label: 'Event Schedule', to: '/schedule', kind: 'app' },
        { label: 'Event Registration', to: 'https://larpchronicles.com/registration', kind: 'external' },
        { label: 'Post-Event Feedback', to: 'https://larpchronicles.com/feedback', kind: 'external' },
    ] },
    { title: 'Game Resources', links: [
        { label: 'Rulebook', to: '/rulebook', kind: 'app' },
    ] },
    { title: 'Player Resources', links: [
        { label: 'Chronicles Discord Server', to: 'https://larpchronicles.com/discord', kind: 'external' },
        { label: 'Code of Conduct', to: 'https://larpchronicles.com/codeofconduct', kind: 'external' },
        { label: 'Liability Waiver', to: 'https://larpchronicles.com/liabilitywaiver', kind: 'external' },
    ] },
];

export function isActiveNavigationPath(destination, path) {
    if (!destination.startsWith('/')) return false;
    if (destination === '/') return path === '/';
    const paths = destination === '/wiki' ? ['/wiki', '/w']
        : destination === '/plot/wiki' ? ['/plot/wiki', '/plot/w']
        : [destination];
    return paths.some(base => path === base || path.startsWith(`${base}/`));
}
